import {
    collection,
    doc,
    getDoc,
    getDocs
} from "firebase/firestore";

import { db } from "../../firebase/firebaseConfig";

// src/funciones/motores/motorYuta.js

/*
==========================================================
YUTAKE

Motor Yuta

Transforma información técnica del MotorEvaluacion
en información pedagógica para las vistas.

NO evalúa.

NO calcula conocimiento.

NO modifica resultados.

Únicamente interpreta.

Se alimenta del MotorEvaluacion y parámetros globales.

==========================================================
*/

/*
==========================================================
CACHE

Evita consultar Firestore cada vez que el usuario
termina una sesión.

==========================================================
*/

let cacheContexto=null;

let cacheTime=0;

const CACHE_MS=1000*60*5;



/*
==========================================================
LECTURA FIRESTORE

==========================================================
*/

const obtenerColeccion = async(nombre)=>{

    const snapshot=await getDocs(

        collection(

            db,

            nombre

        )

    );

    return snapshot.docs.map(doc=>({

        id:doc.id,

        ...doc.data()

    }));

};



const obtenerDocumento=async(

    ruta,

    id

)=>{

    const snapshot=await getDoc(

        doc(

            db,

            ruta,

            id

        )

    );

    if(!snapshot.exists())
        return null;

    return{

        id:snapshot.id,

        ...snapshot.data()

    };

};



/*
==========================================================
CONTEXTO GENERAL

Toda la información que utiliza Yuta
sale de aquí.

==========================================================
*/

const cargarContextoYuta=async({

    usuario,

    metaId="icfes"

})=>{

    const ahora=Date.now();

    if(

        cacheContexto &&

        ahora-cacheTime<CACHE_MS

    ){

        return cacheContexto;

    }

    const progreso=

        await obtenerDocumento(

            "progreso_metas",

            `${usuario.uid}_${metaId}`

        );



    const carreras=

        await obtenerColeccion(

            "carreras"

        );



    const componentes=

        await obtenerColeccion(

            "componentes"

        );



    const temas=

        await obtenerColeccion(

            "tema_componente"

        );



    const materiasTemas=

        await obtenerColeccion(

            "materias_temas"

        );



    const curvas=

        await obtenerColeccion(

            "curvas_proyeccion"

        );



    const examenes=

        await obtenerColeccion(

            "examenes"

        );



    const metas=

        await obtenerColeccion(

            "metas"

        );



    cacheContexto={

        progreso,

        carreras,

        componentes,

        temas,

        materiasTemas,

        curvas,

        examenes,

        metas

    };



    cacheTime=Date.now();

    return cacheContexto;

};

const clamp = (v,min,max)=>
Math.max(min,Math.min(max,v));

const porcentaje=v=>
Math.round((v||0)*100);

const nombreEstado = indice=>{

    if(indice>=0.90) return "Dominio logrado";
    if(indice>=0.75) return "Preparación sólida";
    if(indice>=0.60) return "Necesita consolidación";
    return "Necesita más entrenamiento";

};

const colorEstado = indice=>{

    if(indice>=0.90) return "#22C55E";
    if(indice>=0.75) return "#4ADE80";
    if(indice>=0.60) return "#FACC15";
    return "#EF4444";

};

const rango = indice=>{

    if(indice>=0.90) return "👑 ELITE";
    if(indice>=0.80) return "🏆 AVANZADO";
    if(indice>=0.70) return "🥇 COMPETENTE";
    if(indice>=0.60) return "🥈 EN DESARROLLO";
    return "🥉 INICIAL";

};

const velocidadTexto = velocidad=>{

    if(velocidad==null)
        return "--";

    if(velocidad>=1.15)
        return "Excelente";

    if(velocidad>=0.95)
        return "Buena";

    if(velocidad>=0.75)
        return "Moderada";

    return "Lenta";

};

const fraseProfesor = indice=>{

    if(indice>=0.90)
        return "Excelente trabajo. Cada sesión como esta fortalece tu preparación.";

    if(indice>=0.75)
        return "Vas por muy buen camino. La constancia comienza a convertirse en dominio.";

    if(indice>=0.60)
        return "Ya existe progreso, pero todavía podemos construir una base mucho más sólida.";

    return "No te preocupes por los errores. Son exactamente la información que necesito para ayudarte a mejorar.";

};

const recomendacion = (estadoAcademico)=>{

    if(estadoAcademico.suficiente)
        return "Mi recomendación es comenzar un tema nuevo de esta misma materia.";

    if(estadoAcademico.variables.precision>=0.85)
        return "Una práctica adicional debería ser suficiente para consolidar este contenido.";

    if(estadoAcademico.variables.precision>=0.70)
        return "Conviene repetir este entrenamiento antes de avanzar.";

    return "No avances todavía. Reforzar este contenido tendrá un mayor impacto sobre tu puntaje.";

};

const mensajeImpacto = ({
    estadoAcademico,
nombreObjetivo,
nombreExamen
})=>{

    if(estadoAcademico.suficiente){

        return `Este contenido ya se encuentra por encima del nivel esperado para ${nombreExamen}. Puedes comenzar a invertir más tiempo en otros temas.`;

    }

    if(estadoAcademico.variables.precision>=0.75){

        return `Estás muy cerca del nivel esperado para ${nombreObjetivo}. Un entrenamiento adicional probablemente lo convertirá en una fortaleza.`;

    }

    if(estadoAcademico.variables.precision>=0.60){

        return `Todavía existen vacíos que podrían costarte puntos el día del examen. Aún no conviene abandonar este contenido.`;

    }

    return `Actualmente ${nombreObjetivo} continúa siendo uno de los factores que más limita tu puntaje estimado.`;

};

const calcularProbabilidad = ({
indice,
puntajeActual,
puntajeObjetivo
})=>{

    if(!puntajeObjetivo)
        return 0;

    const progreso=

        clamp(

            puntajeActual/
            puntajeObjetivo,

            0,

            1

        );

    return Math.round(

        (

            progreso*0.65+

            indice*0.35

        )*100

    );

};

const obtenerCurvaPuntaje = (

    curvas,

    indice,

    examenId

)=>{

    if(!curvas?.length)
        return null;

    return curvas.find(curva=>

        Number(curva.ExamenID)===Number(examenId)

        &&

        indice>=Number(curva.IndiceMin)

        &&

        indice<=Number(curva.IndiceMax)

    );

};

const calcularPuntajeEstimado=({

    curvas,

    indice,

    objetivo,

    examenId

})=>{

    const curva=

    obtenerCurvaPuntaje(

        curvas,

        indice,

        objetivo?.ExamenID ??

        examenId

    );

    if(!curva){

        return Math.round(

            indice*500

        );

    }

    const indiceMin=

        Number(curva.IndiceMin);

    const indiceMax=

        Number(curva.IndiceMax);

    const puntajeMin=

        Number(curva.PuntajeMin);

    const puntajeMax=

        Number(curva.PuntajeMax);

    const proporcion=

        (indice*100-indiceMin) /

        (indiceMax-indiceMin);

    return Math.round(

        puntajeMin+

        (puntajeMax-puntajeMin)

        *

        proporcion

    );

};

const crearResumenSesion=({

    estadoAcademico,

tipo,

nombreExamen,

nombreObjetivo

})=>{

    const indice =

    estadoAcademico.indice ?? 0;

    return{

        titulo:

            tipo==="simulacro"

            ?"🧪 Simulacro analizado"

            :"🎯 Entrenamiento completado",

        subtitulo:

            tipo==="simulacro"

            ?`He terminado de evaluar tu simulacro para ${nombreExamen}.`

            :`Analicé tu progreso en ${nombreObjetivo} para ${nombreExamen}.`,

        estado:

            nombreEstado(indice),

        estadoColor:

            colorEstado(indice),

        rango:

            rango(indice),

        fraseProfesor:

            fraseProfesor(indice),

            velocidad:

            velocidadTexto(
            
                estadoAcademico.variables.velocidad
            
            ),

        mensajeImpacto:

            mensajeImpacto({

                estadoAcademico,

                nombreObjetivo,

                nombreExamen

            }),

        recomendacion:

            recomendacion(estadoAcademico)

    };

};

/*
==========================================================
DIAGNÓSTICO POR MATERIAS

Convierte progreso_metas.materiasStats
al formato esperado por DiagnosisCard

==========================================================
*/

const construirDiagnostico=(progreso={})=>{

    const materias=

        progreso.materiasStats??

        {};

    return Object.entries(materias)

    .map(([nombre,datos])=>{

        const correctas=

            datos.correctas??0;

        const incorrectas=

            datos.incorrectas??0;

        const total=

            correctas+

            incorrectas;

        const dominio=

            total===0

            ?0

            :Math.round(

                correctas/

                total*

                100

            );

        return{

            componente:nombre,

            dominio,

            tendencia:

    dominio>=80

        ?"SUBIENDO"

        :dominio>=60

        ?"ESTABLE"

        :"CRÍTICO",

        };

    })

    .sort(

        (a,b)=>

        b.dominio-

        a.dominio

    );

};

const obtenerDominioMateria = (

    progreso,

    materia

)=>{

    const datos=

        progreso?.materiasStats?.[materia];

    if(!datos)
        return 0;

    const correctas=

        datos.correctas??0;

    const incorrectas=

        datos.incorrectas??0;

    const total=

        correctas+

        incorrectas;

    if(total===0)
        return 0;

    return correctas/total;

};



const calcularImpactoTema=({

    tema,

    materia,

    progreso

})=>{

    const dominio=

        obtenerDominioMateria(

            progreso,

            materia

        );

    const debilidad=

        1-dominio;

    const pesoHistorico=

        Number(

            tema.PesoHistorico??

            1

        );

    const importancia=

        Number(

            tema.ImportanciaPedagogica??

            1

        );

    const peso=

        Number(

            tema.Peso??

            1

        );

    return(

        debilidad*

        0.45+

        pesoHistorico*

        0.25+

        importancia*

        0.20+

        peso*

        0.10

    );

};

const generarExplicacionTema = ({

    dominio,

    pesoHistorico,

    importancia,

    peso

})=>{

    const razones=[];

    if(dominio<0.50){

        razones.push(

            "tu dominio todavía es bajo"

        );

    }else if(dominio<0.70){

        razones.push(

            "todavía puedes consolidarlo"

        );

    }

    if(pesoHistorico>=4){

        razones.push(

            "aparece frecuentemente en exámenes"

        );

    }

    if(importancia>=4){

        razones.push(

            "es un tema fundamental"

        );

    }

    if(peso>=4){

        razones.push(

            "tiene un peso alto en la evaluación"

        );

    }

    if(razones.length===0){

        razones.push(

            "puede mejorar tu puntaje"

        );

    }

    return razones.join(", ");

};

/*
==========================================================
TEMAS PRIORITARIOS

Usa la importancia pedagógica
del tema.

==========================================================
*/

const construirTemasPrioritarios=(

    contexto,

    cantidad=5

)=>{

    const progreso=

        contexto.progreso??{};

    return contexto.temas

    .map(tema=>{

        const info=

            contexto.materiasTemas.find(

                t=>

                Number(t.ID)===

                Number(tema.TemaID)

            );

        const materia=

            info?.Materia??

            "";

        const impacto=

            calcularImpactoTema({

                tema,

                materia,

                progreso

            });

        return{

            id:

                tema.TemaID,

            nombre:

                info?.Tema??

                tema.TemaDescripcion,

            materia,

            descripcion:

                info?.Descripcion_breve??

                "",

            impacto,

            explicacion:

    generarExplicacionTema({

        dominio:

            obtenerDominioMateria(

                progreso,

                materia

            ),

        pesoHistorico:

            Number(

                tema.PesoHistorico??

                1

            ),

        importancia:

            Number(

                tema.ImportanciaPedagogica??

                1

            ),

        peso:

            Number(

                tema.Peso??

                1

            )

    }),

            dominio:

                obtenerDominioMateria(

                    progreso,

                    materia

                )

        };

    })

    .sort(

        (a,b)=>

        b.impacto-a.impacto

    )

    .slice(0,cantidad)

    .map(tema=>({

        ...tema,

        impacto:

            Math.round(

                tema.impacto*100

            )

    }));

};



/*
==========================================================
PLAN DIARIO

==========================================================
*/

const construirPlanHoy=(

    contexto

)=>{

    return construirTemasPrioritarios(

        contexto,

        4

    )

    .map((tema,index)=>({

        orden:

            index+1,

        titulo:

            tema.nombre,

        subtitulo:

            tema.explicacion,

        materia:

            tema.materia,

        tiempo:

            tema.dominio<0.50

            ?35

            :20,

        preguntas:

            tema.dominio<0.50

            ?25

            :15,

        prioridad:

            tema.impacto

    }));

};



/*
==========================================================
PROYECCIÓN DE CARRERAS

==========================================================
*/

const construirCarreras = ({

    contexto,

    puntajeActual,

    indice,

    metaId

}) => {

    const carreras =

        (contexto.carreras || [])

        .filter(carrera => {

            if (Number(carrera.Activo ?? 1) !== 1)
                return false;

            if (!metaId)
                return true;

            return (
                String(carrera.ExamenID ?? "")
                    .toLowerCase() ===
                String(metaId)
                    .toLowerCase()
            );

        })

        .sort((a,b)=>

            Number(a.PuntajeCorte) -

            Number(b.PuntajeCorte)

        )

        .slice(0,5);

    return carreras.map(carrera=>({

        nombre:

            carrera.Carrera,

        universidad:

            carrera.Universidad,

        ciudad:

            carrera.Ciudad,

        puntajeObjetivo:

            Number(carrera.PuntajeCorte),

        puntajeActual,

        diferencia:

            Number(carrera.PuntajeCorte)-puntajeActual,

        probabilidad:

            Math.min(

                99,

                calcularProbabilidad({

                    indice,

                    puntajeActual,

                    puntajeObjetivo:

                        Number(carrera.PuntajeCorte)

                })

            ),

        estado:

            puntajeActual>=Number(carrera.PuntajeCorte)

                ?"Admisión probable"

                :"Debe mejorar"

    }));

};

const crearDashboard=({

    estadoAcademico,

    usuario,

    objetivo,

    contexto

})=>{

    const indice =

    estadoAcademico.indice ?? 0;

        const carreraObjetivo=

        contexto.carreras.find(
    
            c=>
    
            Number(c.ID)===
    
            Number(
    
                usuario.carreraObjetivo
    
            )
    
        );    

    const progreso=

        contexto.progreso??

        {};

        

        const examen = {

            1: "ICFES",
        
            2: "UNAL",
        
            3: "UDEA"
        
        }[usuario.examenPrincipal] ?? "UNAL";
        
        const puntajeActual =
        
            estadoAcademico.proyecciones?.[examen]?.puntaje ?? 0;

    return{

        mensajePrincipal:

            fraseProfesor(indice),

            puntajeEstimado:
    puntajeActual,

    probabilidad:

    calcularProbabilidad({

        indice,

        puntajeActual,

        puntajeObjetivo:

            Number(

                carreraObjetivo?.PuntajeCorte ?? 0

            )

    }),

    carreraObjetivo:{

        id:
            carreraObjetivo?.ID,
    
        nombre:
            carreraObjetivo?.Carrera,
    
        universidad:
            carreraObjetivo?.Universidad,
    
        ciudad:
            carreraObjetivo?.Ciudad,
    
        puntaje:
            Number(
                carreraObjetivo?.PuntajeCorte ?? 0
            )
    
    },
        
        nivel:
        
            rango(indice),
        
        estado:
        
            nombreEstado(indice),
        
        porcentajeDominio:
        
            Math.round(indice*100),    

        diagnostico:

            construirDiagnostico(

                progreso

            ),

        temasPrioritarios:

            construirTemasPrioritarios(

                contexto

            ),

        planHoy:

            construirPlanHoy(

                contexto

            ),

            puntajeObjetivo:

carreraObjetivo

?

Number(

    carreraObjetivo.PuntajeCorte

)

:

0,

            potencialCarreras:

            construirCarreras({
        
                contexto,
        
                indice,
        
                puntajeActual,
        
                metaId:
        
                    objetivo?.metaId ??
        
                    objetivo?.id ??
        
                    objetivo?.ExamenID ??
        
                    null
        
            })

    };

};

const crearMotorYuta = ({

    estadoAcademico,

    usuario,

    objetivo = {},

    contexto,

    tipo="tema",

    nombreExamen="ICFES",

    nombreObjetivo="Tema"

})=>{

    

    return{

        dashboard:
    
            crearDashboard({
    
                estadoAcademico,
    
                usuario,
    
                objetivo,
    
                contexto
    
            }),
    

    resumenSesion:

    crearResumenSesion({

        estadoAcademico,

        tipo,

        nombreExamen,

        nombreObjetivo

    }),

        contexto

    };

};

export default {
    crearMotorYuta,
    nombreEstado,
    colorEstado
};